import { AT_TYPES, RESOURCE_KEYS, RESOURCE_URI_CHUNKS } from "./entity.js";
import { OPERATIONS } from "./operations.js";

// -- RESOURCE AND PLANNER MAPPING FOR SCHEDULES -- //

// don't like the degree to which this is mapped, but better here than spread all over the code base for now.
export const ALL_RESOURCES = [
  {
    "@type": AT_TYPES.WORKSTATION,
    key: RESOURCE_KEYS.WORKSTATIONS,
    plannerKey: RESOURCE_KEYS.WORKSTATION_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.WORKSTATIONS,
    operations: {
      add: OPERATIONS.ADD_WORKSTATION
    }
  },
  {
    "@type": AT_TYPES.DISPLAY_GATEWAY,
    key: RESOURCE_KEYS.DISPLAY_GATEWAYS,
    plannerKey: RESOURCE_KEYS.DISPLAY_GATEWAY_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.DISPLAY_GATEWAYS,
    operations: {
      add: OPERATIONS.ADD_DISPLAY_GATEWAY
    }
  },
  {
    "@type": AT_TYPES.CONTAINER,
    key: RESOURCE_KEYS.CONTAINERS,
    plannerKey: RESOURCE_KEYS.CONTAINER_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.CONTAINERS,
    operations: {
      add: OPERATIONS.ADD_CONTAINER
    }
  },
  {
    "@type": AT_TYPES.DATABASE,
    key: RESOURCE_KEYS.DATABASES,
    plannerKey: RESOURCE_KEYS.DATABASE_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.DATABASES,
    operations: {
      add: OPERATIONS.ADD_DATABASE
    }
  },
  {
    "@type": AT_TYPES.NODE,
    key: RESOURCE_KEYS.NODES,
    plannerKey: RESOURCE_KEYS.NODE_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.NODES,
    operations: {
      add: OPERATIONS.ADD_NODE
    }
  },
  {
    "@type": AT_TYPES.SNOWFLAKE,
    key: RESOURCE_KEYS.SNOWFLAKES,
    plannerKey: RESOURCE_KEYS.SNOWFLAKE_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.SNOWFLAKES,
    operations: {
      add: OPERATIONS.ADD_SNOWFLAKE
    }
  },
  {
    "@type": AT_TYPES.VPN_GATEWAY,
    key: RESOURCE_KEYS.VPN_GATEWAYS,
    plannerKey: RESOURCE_KEYS.VPN_GATEWAY_PLANNERS,
    URIChunk: RESOURCE_URI_CHUNKS.VPN_GATEWAYS,
    operations: {
      add: OPERATIONS.ADD_VPN_GATEWAY
    }
  }
];
